// import { BrowserRouter, Routes, Route } from "react-router-dom";
import {  _ProductDetail } from "./Products";
import ProductBox from "./ProductBox";
import Sorting from "./Sorting";
interface ProductListProps {
  paginationOn: boolean;
    // Define your prop types here
    pData: _ProductDetail[];
    sortingActive: any;
    handleSorting: any;
    productID: number;
    handleProductItem: any;
    prevPagination: any;
    nextPagination: any;
    numPage: any;
    nextPageCount: any;
   
  };
const ProductList: React.FC<ProductListProps> = ({paginationOn, pData, sortingActive, handleSorting, productID, handleProductItem, prevPagination, nextPagination, numPage, nextPageCount }) => {
  // console.log("PRODUCTLIST SE VYRENDEROVAL");
  return (
    <div className="archive">
      <Sorting
        sortingActive={sortingActive}
        handleSorting={handleSorting}
      />
      <div className="products">
        <ProductBox 
          item={pData}
          productID={productID}
          handleProductItem={handleProductItem}
        />
      

      </div>
      {
  (numPage > 0 && paginationOn) && (
      <div className="row-end margin-bottom-1">
        
        {
        numPage == 1  ? 
          <button className="btn btn-small disabled">Předchozí</button>
          : <button className="btn btn-small" onClick={() => prevPagination()}>Předchozí</button>
        }
        <span className="num-page">Stránka {numPage}</span>
        {nextPageCount < 1  ?
          <button className="btn btn-small disabled">Další</button>
          : <button className="btn btn-small" onClick={() => nextPagination()}>Další</button>
        }


      </div>
  )}
      
    </div>



  );
};

export default ProductList;
